import {
  Component,
  Injector,
  Optional, SecurityContext
} from '@angular/core';
import {CommonModule} from "@angular/common";
import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, styler,register } from "@wm/components-base";
import {isString} from "lodash-es";

const DEFAULT_CLS =' embed-responsive app-iframe';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-webview',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmWebview]',
  template: `<iframe class="embed-responsive-item iframe-content" scrolling="auto" marginheight="0" marginwidth="0" frameborder="0" seamless="seamless"></iframe>`,
  providers: [
    provideAsWidgetRef(WebviewComponent)
  ],
  exportAs: 'wmWebview',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class WebviewComponent extends StylableComponent {
  static initializeProps = register('wm-webview')

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }



}

